import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const clientId = () => {
  try {
    let id = sessionStorage.getItem("doclyx_analytics_id");
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem("doclyx_analytics_id", id);
    }
    return id;
  } catch {
    return "anonymous";
  }
};

const utmData = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const fresh = ["utm_source", "utm_medium", "utm_campaign"].reduce((acc, key) => {
      const value = params.get(key);
      if (value) acc[key] = value;
      return acc;
    }, {});
    if (Object.keys(fresh).length) {
      sessionStorage.setItem("doclyx_utm", JSON.stringify(fresh));
      return fresh;
    }
    return JSON.parse(sessionStorage.getItem("doclyx_utm") || "{}");
  } catch {
    return {};
  }
};

export const trackEvent = (event, data = {}) => {
  axios.post(`${API}/analytics/event`, { event, client_id: clientId(), ...utmData(), ...data }).catch(() => {});
};
